import moment from 'moment/moment';
import axios from 'axios';
import History from '../components/history/History.vue';
import Photo from '../../../sharedComponents/photo/Photo.vue';
import QrCodeScanner from '../../../sharedComponents/qr-code-scanner/QrCodeScanner.vue';
import IndividualDocInfoPanel from '../docInfo/individual/IndividualDocInfoPanel.vue';
import LegalDocInfoPanel from '../docInfo/legal/LegalDocInfoPanel.vue';

export default {
  props: ['action_id', 'id'],
  components: { History, Photo, QrCodeScanner, IndividualDocInfoPanel, LegalDocInfoPanel },
  data() {
    return {
      // Адреса
      addresses: [],
      // v-model для автокомплита адресов
      searchAddress: '',
      // Города
      cities: [],
      // v-model для автокомплита городов
      searchCity: '',
      // Валидная ли форма?
      valid: false,
      // Процесс создания покупки
      submitIsProcessing: false,
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      // Процесс инициализации qr-кода
      sendingQr: false,
      // Идентификатор продажи
      saleID: this.$props.id,
      // Форма регистрации продажи
      form: {
        qrcode_t: '',
        qrcode_s: '',
        qrcode_fn: '',
        qrcode_i: '',
        qrcode_fp: '',
        qrcode_n: '1',
        comment: '',
        date_setup: '',
        date_setup_local: '',
        sale_id: this.$props.id,
        action_id: this.$props.action_id,
        address: '',
        city_id: null,
        positions: [],
        ticket_photo: [],
        video_url: '',
        ttn: '',
        ttn_sum: '',
        company: null,
        customer_inn: null,
        type: 'INDIVIDUAL',
      },
    };
  },
  computed: {
    // Пользователь
    user() {
      return this.$store.state.user;
    },
    // Показывать ли кнопку "Создать черновик"
    isShowDraftButton() {
      return !this.$store.state.sales.sale?.id || this.$store.state.sales.sale?.status === 'draft';
    },
    // История открытой продажи
    history() {
      return this.sale?.history ?? [];
    },
    // Акция
    action() {
      return this.$store.state.sales.actions.ticket;
    },
    // Продажа
    sale() {
      return this.$store.state.sales.sale;
    },
    // Процесс выполнения запроса к серверу
    loading() {
      return this.$store.state.loading;
    },
    // Возможность редактирования формы
    isEditable() {
      return (
        this.saleID === 'null'
        || !!(
          this.sale
          && this.sale.action.is_actual
          && (this.sale.status === 'draft' || this.sale.status === 'redo')
        )
      );
    },
    // Сформированный qr-код
    buildQr() {
      let qrcode = '';
      if (this.form.date_setup && this.form.qrcode_t) {
        qrcode = `t=${moment(
          `${this.form.date_setup_local} ${this.form.qrcode_t}`,
          'DD.MM.YYYY HH:mm',
        ).format('YYYYMMDD[T]HHmm')}`;
      }
      qrcode += `&s=${this.form.qrcode_s}`;
      qrcode += `&fn=${this.form.qrcode_fn}`;
      qrcode += `&i=${this.form.qrcode_i}`;
      qrcode += `&fp=${this.form.qrcode_fp}`;
      qrcode += `&n=${this.form.qrcode_n}`;

      return qrcode;
    },
  },
  watch: {
    /** Вотчер для автокомплита адресов */
    searchAddress(query) {
      if (query) {
        const app = this;
        const info = { count: 20, query };
        const config = {
          headers: {
            Accept: 'application/json, text/javascript, */*; q=0.01',
            Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
            'Content-Type': 'application/json',
          },
        };

        axios
          .post('https://dadata.ru/api/v2/suggest/address', info, config)
          .then((res) => {
            app.addresses = res.data.suggestions;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
  },
  methods: {
    /**
     * Установка предзагруженных значений при редактировании продажи.
     */
    setDataPreload() {
      if (this.saleID !== 'null' && this.saleID !== undefined) {
        const app = this;
        this.form = { ...app.sale };
        if (app.sale.address) {
          this.addresses.push({
            value: app.sale.address,
          });
        }
        if (app.sale.city) {
          this.cities.push({ ...app.sale.city });
        }
        setTimeout(() => {
          this.checkQr = app.sale.tickets.length > 0;
        }, 200);
      }
    },
  },
  created() {
    this.$store.dispatch('sales/GetSale', +this.saleID).then((res) => {
      if (res) {
        this.$store.dispatch('sales/GetAction', {
          action_id: res.action.id,
        });
      }
    });
  },
  mounted() {
    this.$watch('form.date_setup', (val) => {
      this.checkQr = false;
      this.form.date_setup_local = val && moment(val).format('DD.MM.YYYY');
    });
    this.$watch('form.qrcode_t', () => {
      this.checkQr = false;
    });
    this.$watch('form.qrcode_s', () => {
      this.checkQr = false;
    });
    this.$watch('form.qrcode_fn', () => {
      this.checkQr = false;
    });
    this.$watch('form.qrcode_i', () => {
      this.checkQr = false;
    });
    this.$watch('form.qrcode_fp', () => {
      this.checkQr = false;
    });
    this.setDataPreload();
  },
};
